import React, { useEffect, useState } from 'react';
import SingleService from '../SingleService/SingleService'

const Services = () => {
    const [data, setData] = useState([]);
    useEffect(() => {
        fetch('serviceData.json')
            .then(res => res.json())
            .then(data => setData(data))
    }, []);
    console.log(data);
    return (
        <section className='service py-5'>
            <div className="container">
                <div className="service-title pt-4 pb-4 text-center">
                    <h2 className='fw-bolder fs-1 ' style={{ color: 'rgb(26, 62, 52)' }}> MY SERVICES</h2>
                </div>
                <div className="row">
                    {
                        data.map(service => <SingleService
                            key={service.id}
                            service={service}
                        />)
                    }
                </div>
            </div>
        </section>
    );
};

export default Services;